import SmallPopup from "./SmallPopup";

export default function PopupArea({ popupContent, closeModal }) {
  if (!popupContent) return <></>;
  return (
    <SmallPopup
      open={popupContent != null}
      onClose={closeModal}
    >
      {popupContent}
    </SmallPopup>
  );
}
